import PageNotFoundWrp from './PageNotFoundWrp';

export default PageNotFoundWrp;
